module.exports = __webpack_public_path__ + "static/img/2020_grow_in_grace1.91ea5bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel/2020_grow_in_grace1.jpg
// module id = Gg7N
// module chunks = 1